import { render, staticRenderFns } from "./AddonList.vue?vue&type=template&id=9575889e&scoped=true&"
import script from "./AddonList.vue?vue&type=script&lang=js&"
export * from "./AddonList.vue?vue&type=script&lang=js&"
import style0 from "./AddonList.vue?vue&type=style&index=0&id=9575889e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9575889e",
  null
  
)

export default component.exports